var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      class: _vm.ClassProps,
      style: _vm.styleProp,
      attrs: {
        id: _vm.id,
        loading: _vm.loading,
        color: _vm.color,
        block: _vm.block,
        outlined: _vm.outlined,
        disabled: _vm.disable,
        text: _vm.text,
      },
      on: { click: _vm.click },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }